// extracted by mini-css-extract-plugin
export default {"create_task":"CreateTask_create_task__viX4u","list_item":"CreateTask_list_item__xkX7V","btn__input":"CreateTask_btn__input__NzWDZ"};